/**
 * configuration_view.js
 *
 * Renders the configuration page of MachineLogic.
 *
 */

"use strict";
(function () {
  const { controlCenter, machineBuilder } = require('@ventionco/mm-machine-logic-robot');
  const { view: { RobotConfigWidget: ControlCenterRobotConfigWidget } } = controlCenter;
  const { view: { RobotConfigWidget: MachineBuilderRobotConfigWidget } } = machineBuilder;
  const { axisConfigCard } = require('../../legacy/config_ui/axis_config_card');
  const { formatAxisType } = require('../../helpers');

  const $ = require('jQuery');
  const widgets_helper = require('../../legacy/widgets_helper');
  const widgets = require('../../legacy/widgets');
  const helpers = require('../../helpers');
  const icons = require('../../icons');
  const tooltips = require('../../legacy/machinelogic_tooltips');
  const view_widgets = require('../../legacy/view_widgets');
  const machinemotion = require('../../api/machinemotion');
  const style = require('../../legacy/style');
  const configurationEditorStyles = require('./configurationEditor.css');
  const environment = require('../../environment');
  const React = require('react');
  const ReactDOM = require('react-dom');
  let robotConfigWidgets = [];
  /*
    interface ConfigurationProps {
      controllerProps: {
        disableEditing: true,
        hideControllerSettings: true,
        hideNetworkSignifiers: true,
        hidePluggedInSignifiers: true
      },
      actuatorProps: {
        hideDriveSettings: true,
        overrideWidget: (pConfig, pAxis, pIsReadonly) => JQuery;
      },
      inputProps: {
        overrideWidget: (pConfig, pInput, pIsReadonly) => JQuery;
      },
      outputProps: {
        overrideWidget: (pConfig, pOutput, pIsReadonly) => JQuery;
      }
      toolbarProps: {
        showRobotAddButton: true,
        check3DforRobot: true | false // false will show a message box toaster
      }
    }
  */

  /**
   * Renders the configuration view.
   * @param {Navigate} pNavigate A function to navigate to another view.
   * @param {machinelogic.Library} pLibrary
   * @param {JQuery} pControllerContainer Container where the controller tabs will live.
   * @param {JQuery} pLeftContainer Container where the sidebar will live.
   */
  function configurationView(pNavigate, pLibrary, pControllerContainer, pLeftContainer, pConfigurationProps) {
    const lConfigManager = pLibrary.getConfigManager();
    const lControllerSelector = controllerSelector(lConfigManager,
      function(pConfig) { lSelectConfiguration(pConfig); },
      function() { lConfigManager.newConfiguration(); },
      pConfigurationProps?.controllerProps
    );
    let lActiveConfig = undefined;
    const lSelectConfiguration = function(pConfig) {
      if (lSidebarView) {
        lSidebarView.widget.forEach(function(pWidget) { pWidget.remove(); });
        if (lSidebarView.closeDocument) { lSidebarView.closeDocument(); }
        lSidebarView = undefined;
      }

      lActiveConfig = pConfig;

      if (lActiveConfig) {
        const lIsReadonly = pConfigurationProps?.controllerProps?.hideRestrictedView ? false : (!lConfigManager.hasParentAccessLevel() && !lActiveConfig.getController().isHost());
        lSidebarView = configSidebar(pNavigate, lActiveConfig, lIsReadonly, pConfigurationProps);
        lSidebarViewContainer.append(lSidebarView.widget);
        lControllerSelector.selectConfiguration(lActiveConfig);
      } else {
        lSidebarView = configManagerSidebar(lConfigManager);
        lSidebarViewContainer.append(lSidebarView.widget);
        lControllerSelector.selectConfiguration(lActiveConfig);
      }
    };
    const lAddConfiguration = function(pConfig, pIsNew) {
      lControllerSelector.addConfiguration(pConfig);
      if (pIsNew) {
        lSelectConfiguration(pConfig);
      }
    };
    const lRemoveConfiguration = function(pConfig, pIndex) {
      lControllerSelector.removeConfiguration(pConfig, pIndex);

      if (pConfig === lActiveConfig) {
        if (lConfigManager.getConfigurationList().length) {
          let lNextSelectedIndex = pIndex - 1;
          if (lNextSelectedIndex < 0 || lNextSelectedIndex >= lConfigManager.getConfigurationList().length) {
            lNextSelectedIndex = 0;
          }
          lSelectConfiguration(lConfigManager.getConfigurationList()[lNextSelectedIndex]);
        } else {
          lSelectConfiguration(undefined);
        }
      }
    };
    const lInitialize = function() {
      lConfigManager.getAndUpdateConfiguredNetworkStatus( function(lNetworkStatus) {
        console.log("Network status: ", lNetworkStatus);
        lControllerSelector.initialize();
        // For simulation purpose, numberOfDetectedControllers is always 0, thus no need to initialize configuration of controller)
        lSelectConfiguration(lConfigManager.getParentConfiguration());
        // Note (AJ): Post discussion it was decided that the auto-populate flow would left out of the first multi-controller release.
        // I am leaving the code here in for when we decide to bring it back.

        // if(lNetworkStatus.numberOfDetectedControllers === 0) {
        //   console.error('ATTENTION: THIS SHOULD ONLY BE HAPPENING IS A SIMULATED EDGE ENVIRONMENT');
        //   if (lConfigManager.getConfigurationList().length !== 0) {
        //     lControllerSelector.initialize();
        //     lSelectConfiguration(lConfigManager.getParentConfiguration());
        //   }
        // }
        // else {
        //   if (lConfigManager.getConfigurationList().length !== 0) {
        //     lControllerSelector.initialize();
        //     lSelectConfiguration(lConfigManager.getParentConfiguration());
        //   }
        //   if (lNetworkStatus.numberOfDetectedControllers > lConfigManager.getConfigurationList().length) {
        //     showControllerSyncModal(lConfigManager);
        //   }
        // }
      });
    };
    const lReset = function() {
      lControllerSelector.reset();

      if (lSidebarView) {
        $(lSidebarView.widget).remove();
        lSidebarView = undefined;
      }
    };
    const lConfigManagerListener = {
      onReset: lReset,
      onInitialized: undefined,
      onConfigurationAdded: lAddConfiguration,
      onConfigurationRemoved: lRemoveConfiguration
    };
    const lSidebarViewContainer = $('<div class="ml_library v_layout bordered spaced"/>');
    let lSidebarView = undefined;

    pControllerContainer.append(lControllerSelector.widget);
    pLeftContainer.append(lSidebarViewContainer);

    lConfigManager.addListener(lConfigManagerListener);

    lControllerSelector.widget.on('remove', function onConfigTreeRemove() {
      lConfigManager.removeListener(lConfigManagerListener);
    });

    if (pLibrary.isInitialized()) {
      lInitialize();
    }
    else {
      lConfigManagerListener.onInitialized = lInitialize;
    }
  }
  /* eslint-disable no-unused-vars */
  // Note (AJ): Post discussion it was decided that the auto-populate flow would left out of the first multi-controller release.
  // I am leaving the code here in for when we decide to bring it back.
  function showControllerSyncModal(pConfigManager, pSelectConfiguration) {

    const lManualSync = function() {
      if (pConfigManager.getConfigurationList().length === 0) {
        const lBaseConfig = pConfigManager.newConfiguration();
        pConfigManager.setHostControllerUuid(lBaseConfig.getController().getUUID());
        pConfigManager.setParentController(lBaseConfig.getController().getUUID()); // The first configuration can be the parent.
      }
      lModalContainer.remove();
    };

    const lAutoSync = function() {
      pConfigManager.autoPopulateConfigurations(() => {
        pSelectConfiguration(pConfigManager.getParentConfiguration());
      });
      lModalContainer.remove();
    };

    const lModalContainer = $('<div>').addClass('ml_modal_container').appendTo('body').append(
      $('<div>').addClass('ml_modal ml_controller_sync_modal').append(
        $('<div>').append([
          $('<div>').addClass('ml_modal_header').text("Sync MachineMotion Controllers?"),
          $('<p>').text('It looks like you have multiple controllers connected in the same network.\nDo you want to add them to your configuration?')
        ]),
        $('<div>').addClass('ml_modal_footer').append([
          $('<button>').addClass('ml_modal_button inverse').text("No").on('click', lManualSync ),
          $('<button>').addClass('ml_modal_button').text("Yes").on('click', lAutoSync ),
        ]),
      )
    );

    return lModalContainer;
  }
  /* eslint-enable no-unused-vars */


  /**
   * Renders the Controller tabs at the top of the pane.
   *
   * @param {machinelogic.ConfigManager} pConfigManager
   * @param {(machinelogic.Config) => void} pSelectConfig
   * @param {*} pAddConfig
   * @returns
   */
  function controllerSelector(pConfigManager, pSelectConfig, pAddConfig, pControllerProps) {
    // ------------ HTML ------------
    const lDisableEditing = pControllerProps?.disableEditing ?? false;
    const lContainer = $('<div>').addClass('ml_controller_container');
    const lTabContainer = $('<div>').addClass('ml_controller_tab_container').appendTo(lContainer);
    const lAddControllerButton = $('<button>').addClass('ml_add_controller_button').text('+').on('click', pAddConfig).appendTo(lContainer).hide();

    const lWidgetMap = {};

    // Add the all view tab
    const lAllViewItem = $('<div>').addClass('ml_controller_tab').css({maxWidth: '106px'}).appendTo(lTabContainer).append($('<label>').text('Overview')).hide(); // The Overview tab is hidden by default. It is enabled by lCheckIfOnlyController on lInitialize.
    lAllViewItem.on('click', function() { pSelectConfig(null); });
    lWidgetMap['ALL'] = lAllViewItem;

    // ------------ Helper Functions ------------
    function lInitialize() {
      lCheckIfOnlyController();

      // Populate the view with existing configurations
      pConfigManager.getConfigurationList().forEach(function(pConfig) {
        if (lWidgetMap[pConfig.getController().getUUID()] === undefined) { lAddConfiguration(pConfig); }
      });

      // Enable/disable the add button
      if (lDisableEditing) { lAddControllerButton.hide(); }
      else if (!pConfigManager.hasParentAccessLevel()) { lAddControllerButton.hide(); }
      else if (pConfigManager.getConfigurationList().length === pConfigManager.mMaxNumberOfControllers) { lAddControllerButton.hide(); }
      else { lAddControllerButton.show(); }
    }

    function lCheckIfOnlyController() {
      if(pConfigManager.getConfigurationList().length === 1){
        lAllViewItem.hide();
      } else {
        lAllViewItem.show();
      }
    }

    function lReset() {
      pConfigManager.getConfigurationList().forEach(function(pConfig) { lRemoveConfiguration(pConfig); });
    }

    function lAddConfiguration(pConfiguration) {
      if(pConfigManager.getConfigurationList().length === pConfigManager.mMaxNumberOfControllers) {
        lAddControllerButton.hide(); // max allowed controllers reached. Hide button and fill space where button was.
        lTabContainer.css('max-width', '100%');
      }
      // tab container
      const lControllerItem = $('<div>').addClass('ml_controller_tab');
      const lHostIcon = $('<div>', { text: "Plugged into", class: 'ml_controller_plugged_in_indicator' });
      const lControllerName = $('<label>').text(pConfiguration.getController().getFormattedName());
      const lDisabledIcon = $('<i>').addClass(icons.danger).css('color', '#D9534F').css('padding-left', '5px');

      lTabContainer.append(
        lControllerItem.append(
          lHostIcon,
          lControllerName,
          lDisabledIcon
        )
      );

      function lUpdateIconsAndButtons() {
        lHostIcon.hide();
        lDisabledIcon.hide();

        if(!pControllerProps?.hidePluggedInSignifiers && pConfiguration.getController().isHost()) { lHostIcon.show(); }
        if(!pControllerProps?.hideNetworkSignifiers && !pConfiguration.getController().isAvailable()) { lDisabledIcon.show(); }
      }

      lUpdateIconsAndButtons();

      const lControllerListener = {
        onNameChanged: function() { lControllerName.text(pConfiguration.getController().getFormattedName()); }
      };

      const lConfigManagerListener = {
        onConfigDeployed: function() { lUpdateIconsAndButtons(); },
      };

      // Establish name change callback
      pConfiguration.getController().addListener(lControllerListener);
      pConfiguration.getConfigManager().addListener(lConfigManagerListener);
      lControllerItem.on('remove', function() {
        pConfiguration.getController().removeListener(lControllerListener);
        pConfiguration.getConfigManager().removeListener(lConfigManagerListener);
      });
      // Attach callbacks for this tab
      if(pControllerProps?.handleHoverIn && pControllerProps?.handleHoverOut) {
        lControllerItem.attr('id', pConfiguration.getController().mControllerVID);
        lControllerItem.on('mouseenter', (e) => pControllerProps.handleHoverIn(e));
        lControllerItem.on('mouseleave', (e) => pControllerProps.handleHoverOut(e));
      }

      lControllerItem.on('click', function() { pSelectConfig(pConfiguration); });
      lWidgetMap[pConfiguration.getController().getUUID()] = lControllerItem;
      lCheckIfOnlyController();
    }

    function lRemoveConfiguration(pConfiguration) {
      const lUuid = pConfiguration.getController().getUUID();
      lWidgetMap[lUuid].remove();
      delete lWidgetMap[lUuid];
    }

    function lResetTabNames() {
      pConfigManager.getConfigurationList().forEach(function(pConfig) {
        lWidgetMap[pConfig.getController()?.getUUID()]?.find('label').text(pConfig.getController().getFormattedName());
      });
    }

    function lSelectConfiguration(pConfiguration) {
      if(pConfiguration === undefined) { return; } // in the cad, configurations are set to undefined when deleted.
      let lElement;
      if (pConfiguration === null) { lElement = lWidgetMap['ALL']; }
      else {
        lElement = lWidgetMap[pConfiguration.getController().getUUID()];
      }
      lTabContainer.find('.ml_controller_tab_selected').removeClass('ml_controller_tab_selected');
      lElement.addClass('ml_controller_tab_selected');
    }

    // ------------ Attach and remove listeners ------------
    const lConfigManagerListener = {
      onParentConfigurationChanged: lResetTabNames,
      onConfigurationRemoved: function() {
        lCheckIfOnlyController();
        lTabContainer.css('max-width', '');
        lAddControllerButton.show(); // when removing a configuration we can assume we are no longer at the maximum allowed controllers.
        lResetTabNames();
      },
      onConfigurationAdded: lResetTabNames
    };

    pConfigManager.addListener(lConfigManagerListener);
    lContainer.on('remove', function() {
      pConfigManager.removeListener(lConfigManagerListener);
    });

    return {
      widget                : lContainer,
      initialize            : lInitialize,
      reset                 : lReset,
      addConfiguration      : lAddConfiguration,
      removeConfiguration   : lRemoveConfiguration,
      selectConfiguration   : lSelectConfiguration,
    };
  }

  /**
   * Enum containing all of the views available in the configuration view.
   */
  const gViews = Object.freeze({
    NONE      : 0,
    ACTUATOR  : 1,
    INPUT     : 2,
    OUTPUT    : 3,
    ROBOT     : 4
  });

  /**
  * Renders the left sidebar of the Configuration page explicitly. Also renders the
   * main view of the Configuration page via the Document mechanism.
   *
   * @param {Navigate} pNavigate A function to navigate to another view.
   * @param {Config} pConfig
   * @param {Boolean} pIsReadonly
   *
   * @returns {Object} Sidebar for the configuration page
   */
  function configSidebar(pNavigate, pConfig, pIsReadonly, pConfigurationProps) {
    // *********************************
    // HTML
    // *********************************

    // Tree
    const lContainerTreeView = $('<div class="v_layout spaced ml_scrollable">').css("overflow-y", "auto");
    const lConfigWidget = $('<div class="ml_config v_layout spaced"/>').css('padding', '0.5rem');
    const lErrorIcon = $('<i>').addClass(icons.danger).css('color', '#D9534F').addClass('ml_config_tree_view_header_error_icon');

    const lControllerLabel = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.controller }),
      $('<label>', { text: "Controller Settings" }).append(lErrorIcon, $('<i>', { class: icons.define })).addClass('ml_config_tree_view_header_label'), // maybe add the connection warning here
    ).on('click', () => { lOpenControllerSettings(); }).css('padding-bottom', '8px');

    const lActuatorList = $('<ul class="ml_actuator_list v_layout spaced">');
    const lActuatorListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.axis_alternate }).css('padding-right', '6px'),
      $('<label>', { text: 'Actuators' })
    ).on('click', () => { lOpenActuatorView(); });

    const lRobotList = $('<ul class="ml_robot_list v_layout spaced">');
    const lRobotListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.robot }).css('padding-right', '6px'),
      $('<label>', { text: 'Robots' })
    ).on('click', () => { lOpenRobotView(); });

    const lInputList = $('<ul class="ml_input_list v_layout spaced">');
    const lInputListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.input }).css('padding-right', '2px'),
      $('<label>', { text: 'Inputs' })
    ).on('click', () => { lOpenInputView(); });

    const lOutputList = $('<ul class="ml_output_list v_layout spaced">');
    const lOutputListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.output }),
      $('<label>', { text: 'Outputs' })
    ).on('click', () => { lOpenOutputView(); });

    // Toolbar
    const lToolbar = $('<div class="ml_editor_toolbar ml_library_toolbar h_layout"/>');

    const lAddAxisButton = widgets.textIconButton(null, 'Add Actuator', true, icons.axis_add, 'Add actuator', function() {
      lOpenActuatorView();
      const lResult = pConfig.newAxis();
      if(lResult && lResult.error) { widgets.messageBox(lResult.error, 'warning'); }
      else { pConfig.sortAxes(); }
    }, pIsReadonly);

    const lAddRobot = widgets.textIconButton("add_robot_button", 'Add Robot', true, icons.addRobot, 'Add robot', function () {
      pConfig.newRobot();
      lOpenRobotView();
    }, !pConfig.canAddRobots() || pIsReadonly);

    const lAddInputButton = widgets.textIconButton(null, 'Add Input', true, icons.input, 'Add new input', function() {
      lOpenInputView();
      pConfig.newInput();
    }, pIsReadonly);

    const lAddOutputButton = widgets.textIconButton(null, 'Add Output', true, icons.output, 'Add new output', function() {
      lOpenOutputView();
      pConfig.newOutput();
    }, pIsReadonly);

    // Construct the widget
    lConfigWidget.append(
      !pConfigurationProps?.controllerProps?.hideControllerSettings && lControllerLabel,
      lActuatorListHeader,
      lActuatorList,
      pConfig.getController().isHost() && pConfig.getController().isParent()
        ? lRobotListHeader
        : "",
      pConfig.getController().isHost() && pConfig.getController().isParent()
        ? lRobotList
        : "",
      lInputListHeader,
      lInputList,
      lOutputListHeader,
      lOutputList
    );

    lToolbar.append(
      lAddAxisButton,
      lAddRobot,
      lAddInputButton,
      lAddOutputButton
    );

    // *********************************
    // Helper functions
    // *********************************

    function lUpdateAvailabilityIcon() {
      lErrorIcon.hide();
      if( !pConfigurationProps?.controllerProps?.hideNetworkSignifiers && !pConfig.getController().isAvailable() ){
        lErrorIcon.show();
      }
    }
    lUpdateAvailabilityIcon();

    const lMoveItem = function(_lList, pFrom, pTo){
      if(pTo == 0) {
        _lList.prepend($(_lList.children().get(pFrom)));
      } else if(pFrom > pTo){
        $(_lList.children().get(pFrom)).insertAfter($(_lList.children().get(pTo - 1)));
      } else {
        $(_lList.children().get(pFrom)).insertAfter($(_lList.children().get(pTo)));
      }
    };

    const lAppendConfigElement = function (pList, pItem, pIndex) {
      const lConfigElement = $('<div>')
        .attr('title', pItem.getName())
        .text(pItem.getName())
        .css({cursor: 'pointer', width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'});

      // onClick, scroll into view on the right panel
      lConfigElement.click(function () {
        let lElementIndex = -1;

        switch (pList) {
          case lActuatorList:
            lElementIndex = pConfig.listAxes().findIndex(function (pAxis) { return pAxis === pItem; });
            if (lActiveView !== gViews.ACTUATOR) {
              lOpenActuatorView();
            }
            break;
          case lRobotList:
            lElementIndex = pConfig.listRobots().findIndex(function (pRobot) { return pRobot === pItem; });
            if (lActiveView !== gViews.ROBOT) {
              lOpenRobotView();
            }
            break;
          case lInputList:
            lElementIndex = pConfig.listInputs().findIndex(function (pInput) { return pInput === pItem; });
            if (lActiveView !== gViews.INPUT) {
              lOpenInputView();
            }
            break;
          case lOutputList:
            lElementIndex = pConfig.listOutputs().findIndex(function (pOutput) { return pOutput === pItem; });
            if (lActiveView !== gViews.OUTPUT) {
              lOpenOutputView();
            }
            break;
          default:
            return;
        }

        // In case we have to wait for the element to be available on the DOM
        // (because we just opened the view), we execute this after a timeout of zero.
        setTimeout(function () {
          const lActiveList = $('#ml_active_config_list');
          const lListItem = lActiveList.children().eq(lElementIndex);
          if (lListItem.length) {
            lListItem[0].scrollIntoView({ behavior: 'smooth' });
          }
        }, 0);
      });

      if (pIndex === undefined || pList[0].children.length <= pIndex) {
        pList[0].append(lConfigElement[0]);
      } else {
        pList[0].insertBefore(lConfigElement[0], pList[0].children[pIndex]);
      }
    };

    const lAppendAxisElement = function(pAxis) {
      lAppendConfigElement(lActuatorList, pAxis, pAxis.getDriveNumber() - 1);
    };

    const lAppendRobotElement = function(pRobot) {
      lAppendConfigElement(lRobotList, pRobot);
    };

    const lAppendInputElement = function(pInput) {
      lAppendConfigElement(lInputList, pInput);
    };

    const lAppendOutputElement = function(pOutput) {
      lAppendConfigElement(lOutputList, pOutput);
    };
    const lUpdateButtons = function() {
      if (!pIsReadonly) {
        lAddRobot.attr('disabled', !pConfig.canAddRobots());
        lAddAxisButton.attr('disabled', pConfig.isMaxNumberOfAxesReached());
        lAddInputButton.attr('disabled', pConfig.reachedMaxInputCombination());
        lAddOutputButton.attr('disabled', pConfig.reachedMaxOutputCombination());
      }
    };

    const lOnViewOpened = pDocument => {
      $('.ml_disabled_editor').remove();

      showApplicationCheckerHintCard(pNavigate, pConfig, pDocument.widget);

      if (!pIsReadonly) {
        return;
      }

      const lDisabledEditor = $('<div>').addClass("ml_disabled_editor");
      const lWarningMessage = $('<div>').text('Restricted view of this controller. Please connect to the parent controller.');

      lDisabledEditor.append(lWarningMessage);
      $('.ml_editor').append(lDisabledEditor);
    };

    const lOpenControllerSettings = function() {
      if (lActiveView === 'controller') { return; }

      lActiveView = 'controller';

      const lControllerDocument = new view_widgets.Document(pConfig.getController(), controllerSettings(pConfig, pConfigurationProps));

      lActiveDocument = lControllerDocument;

      $('.ml_editor').trigger('open_document', lControllerDocument);
      lConfigWidget.find('.selected').removeClass('selected');
      lControllerLabel.find('label').addClass('selected');
      lOnViewOpened(lControllerDocument);
    };

    const lOpenActuatorView = function() {
      if (lActiveView === gViews.ACTUATOR) { return; }

      lActiveView = gViews.ACTUATOR;

      const lConfigDocument = new view_widgets.Document(pConfig, actuatorEditor(pNavigate, pConfig, pIsReadonly, pConfigurationProps?.actuatorProps));
      lActiveDocument = lConfigDocument;
      $('.ml_editor').trigger('open_document', lConfigDocument);
      lConfigWidget.find('.selected').removeClass('selected');
      lActuatorListHeader.find('label').addClass('selected');
      lOnViewOpened(lConfigDocument);
    };

    const lOpenRobotView = function() {
      if (lActiveView === gViews.ROBOT) { return; }

      lActiveView = gViews.ROBOT;

      robotConfigWidgets.forEach((robotConfigWidget) =>
        ReactDOM.unmountComponentAtNode(robotConfigWidget)
      );
      robotConfigWidgets = [];
      const lConfigDocument = new view_widgets.Document(pConfig, robotEditor(pConfig, pIsReadonly));
      lActiveDocument = lConfigDocument;
      $('.ml_editor').trigger('open_document', lConfigDocument);
      lConfigWidget.find('.selected').removeClass('selected');
      lRobotListHeader.find('label').addClass('selected');
      lOnViewOpened(lConfigDocument);
    };

    const lOpenInputView = function() {
      if (lActiveView === gViews.INPUT) { return; }

      lActiveView = gViews.INPUT;

      const lConfigDocument = new view_widgets.Document(pConfig, inputEditor(pConfig, pConfigurationProps?.inputProps));
      lActiveDocument = lConfigDocument;
      $('.ml_editor').trigger('open_document', lConfigDocument);
      lConfigWidget.find('.selected').removeClass('selected');
      lInputListHeader.find('label').addClass('selected');
      lOnViewOpened(lConfigDocument);
    };

    const lOpenOutputView = function() {
      if (lActiveView === gViews.OUTPUT) { return; }

      lActiveView = gViews.OUTPUT;

      const lConfigDocument = new view_widgets.Document(pConfig, outputEditor(pConfig, pConfigurationProps?.outputProps));
      lActiveDocument = lConfigDocument;
      $('.ml_editor').trigger('open_document', lConfigDocument);
      lConfigWidget.find('.selected').removeClass('selected');
      lOutputListHeader.find('label').addClass('selected');
      lOnViewOpened(lConfigDocument);
    };
    // *********************************
    // Listeners
    // *********************************

    // define listeners
    const lConfigListener = {
      onAxisAdded: function(pAxis) {
        lAppendAxisElement(pAxis);
        lUpdateButtons();
      },
      onChildDriveAdded: function() {
        lUpdateButtons();
      },
      onChildDriveRemoved: function () {
        lUpdateButtons();
      },
      onAxisRemoved: function(pAxis){
        const _lListItem = lActuatorList.find("[title='" + pAxis.getName() + "']");
        _lListItem[0].remove();
        lUpdateButtons();
      },
      onAxisMoved : function(pFrom, pTo) {
        lMoveItem(lActuatorList, pFrom, pTo);
      },
      onAxisNameChanged: function(pAxis) {
        const lIndexInList = pConfig.listAxes().indexOf(pAxis);
        const lNameValue = $(lActuatorList.children().get(lIndexInList));
        lNameValue.text(pAxis.getName());
        lNameValue.attr('title', pAxis.getName());
      },
      onAxesSorted: function() {
        lActuatorList.empty();
        pConfig.listAxes().forEach(function(pAxis) {
          lAppendAxisElement(pAxis);
        });
      },
      onRobotAdded: function(pRobot){
        lAppendRobotElement(pRobot);
        lUpdateButtons();
      },
      onRobotRemoved: function () {
        lRobotList.children()[0].remove();
        lUpdateButtons();
      },
      onRobotNameChanged: function(pName){
        const lChildrenIndex = pConfig.listRobots().findIndex((pRobot) => pRobot.getName() === pName);
        const lNameValue = $(lRobotList.children().get(lChildrenIndex));
        lNameValue.text(pName);
        lNameValue.attr('title', pName);
      },
      onInputAdded: function(pInput) {
        lAppendInputElement(pInput);
        lUpdateButtons();
      },
      onOutputAdded: function(pOutput) {
        lAppendOutputElement(pOutput);
        lUpdateButtons();
      },
      onInputRemoved: function(pInput) {
        const _lIoItem = lInputList.find("[title='" + pInput.getName() + "']");
        _lIoItem[0].remove();
        lUpdateButtons();
      },
      onOutputRemoved: function(pOutput) {
        const _lIoItem = lOutputList.find("[title='" + pOutput.getName() + "']");
        if (_lIoItem.length) {
          _lIoItem[0].remove();
        }
        lUpdateButtons();
      },
      onInputMoved: function(pFrom, pTo) { lMoveItem(lInputList, pFrom, pTo); },
      onOutputMoved: function(pFrom, pTo) { lMoveItem(lOutputList, pFrom, pTo); },
      onInputNameChanged: function(pName) {
        const lInputIndex = pConfig.listInputs().findIndex(function(pInput) { return pInput.getName() === pName; });
        if (lInputIndex >= 0) {
          const lInputItem = lInputList.children().eq(lInputIndex);
          lInputItem.attr('title', pName);
          lInputItem.text(pName);
        }
      },
      onOutputNameChanged: function(pName) {
        const lOutputIndex = pConfig.listOutputs().findIndex(function(pOutput) { return pOutput.getName() === pName; });
        if (lOutputIndex >= 0) {
          const lOutputItem = lOutputList.children().eq(lOutputIndex);
          lOutputItem.attr('title', pName);
          lOutputItem.text(pName);
        }
      },
      onIOMapUpdate: lUpdateButtons,
      onAxisInputOutputChanged: function() {
        // this is used to sync ADD buttons as the `onAxis[Pin|Device]Changed` will trigger too many blockNotAvailableControlModules
        lUpdateButtons();
      }
    };

    const lConfigManagerListener = {
      onActuatorsChanged: lUpdateButtons,
      onParentConfigurationChanged: function() {
        !pConfigurationProps?.controllerProps?.hideControllerSettings && lControllerLabel.find('label').text(pConfig.getController().getFormattedName());
      },
      onConfigDeployed: function() { lUpdateAvailabilityIcon(); },
    };

    // attach and detach listeners
    pConfig.addListener(lConfigListener);
    pConfig.getConfigManager().addListener(lConfigManagerListener);

    lConfigWidget.on('remove', function onConfigTreeRemove() {
      pConfig.removeListener(lConfigListener);
      pConfig.getConfigManager().removeListener(lConfigManagerListener);
    });


    // *********************************
    // initialization logic
    // *********************************
    let lActiveView = gViews.NONE;
    let lActiveDocument = undefined;

    // Populate with the default data
    pConfig.listAxes().forEach(lAppendAxisElement);
    pConfig.listRobots().forEach(lAppendRobotElement);
    pConfig.listInputs().forEach(lAppendInputElement);
    pConfig.listOutputs().forEach(lAppendOutputElement);
    // Disable the buttons if needed
    lUpdateButtons();

    // We will open the Configuration at the overview page. Note that we have
    // to do this inside of a setTimeout to ensure that the documentContainer
    // is already on the DOM. This should be refactored eventually.
    setTimeout(() => {
      pConfigurationProps?.controllerProps?.hideControllerSettings ?
        lOpenActuatorView() :
        lOpenControllerSettings();
    }, 0);

    let lWidget;
    if(environment.isOnPendant()) {
      const lConfigManager = pConfig.getConfigManager();
      const [lMessageUi, lApplyButton] = _applyConfigurationButton(lConfigManager, function () {
        lConfigManager.deploy(
          function (result) {
            if(result === null) {
              console.error('failed to deploy configuration');
              return;
            }

            lApplyButton?.clear();
            pConfig.mLibrary.robotAppsService.send(
              pConfig.listRobots().length
                ?  "Configuration/ApplyConfigurationButtonClicked/WithRobotConfig"
                :  "Configuration/ApplyConfigurationButtonClicked/WithNoRobotConfig"
            );
          });
      });
      lConfigManager.addListener({ onSetDirty : function() { lApplyButton.set(); } });
      lWidget = [ lContainerTreeView.append(lConfigWidget), lMessageUi, lApplyButton, lToolbar];
    }
    else {
      lWidget = [ lContainerTreeView.append(lConfigWidget), lToolbar ];
    }

    return {
      widget          : lWidget,
      closeDocument   : function() {
        if (lActiveDocument) {
          lActiveDocument.tab.remove();
          lActiveDocument.buttons.forEach(pButton => pButton.detach());
          lActiveDocument = undefined;
        }
      }
    };
  }

  /**
   * Renders the left sidebar of the Configuration page when the "All" options is selected explicitly.
   * Also renders all via allConfigurationView the Document mechanism.
   *
   * @param {ml.ConfigManager} pConfigManager
   *
   * @returns {Object} Sidebar for the configuration page
   */

  function configManagerSidebar(pConfigManager) {
    // *********************************
    // HTML
    // *********************************

    // Tree
    const lContainerTreeView = $('<div class="v_layout spaced ml_scrollable">');
    const lConfigWidget = $('<div class="ml_config v_layout spaced"/>').css('padding', '0.5rem').appendTo(lContainerTreeView);

    const lActuatorList = $('<ul class="v_layout spaced">').css({marginTop: '0px', marginBottom: '0.25rem'});
    const lActuatorListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.axis_alternate }),
      $('<label>', { text: 'Actuators' })
    );

    const lInputList = $('<ul class="v_layout spaced">').css({marginTop: '0px', marginBottom: '0.25rem'});
    const lInputListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.input }),
      $('<label>', { text: 'Inputs' })
    );

    const lOutputList = $('<ul class="v_layout spaced">').css({marginTop: '0px', marginBottom: '0.25rem'});
    const lOutputListHeader = $('<div>', { class: 'ml_config_tree_view_header h_layout' }).append(
      $('<i>', { class: icons.output }),
      $('<label>', { text: 'Outputs' })
    );

    // Construct the widget
    lConfigWidget.append(
      lActuatorListHeader,
      lActuatorList,
      lInputListHeader,
      lInputList,
      lOutputListHeader,
      lOutputList
    );

    const lAppendConfigElement = function(pList, pItem) {
      const lConfigElement = $('<div class="h_layout spaced title_holder">').attr('title', pItem.getName())
        .append(widgets.autoResizeTextInput(pItem.getName()).addClass('ml_tree_document').disable());
      pList.append(lConfigElement);
    };

    // Populate with the default data
    pConfigManager.listAxes().forEach((pAxis) => { lAppendConfigElement(lActuatorList, pAxis); });
    pConfigManager.listInputs().forEach((pInput) => { lAppendConfigElement(lInputList, pInput); });
    pConfigManager.listOutputs().forEach((pOutput) => { lAppendConfigElement(lOutputList, pOutput); });

    const allControllersDocument = new view_widgets.Document(pConfigManager, allConfigurationView(pConfigManager), []);
    $('.ml_disabled_editor').remove();
    $('.ml_editor').trigger('open_document', allControllersDocument);

    return {
      widget: [lContainerTreeView],
    };
  }

  /**
   * Helper function for the generic gray headers that you see at the top of our editors.
   * @param {String} pText Text to display in the header.
   * @param {String | undefined} pControllerSubtitle Controller subtitle to display on top.
   * @returns {JQuery} Header element
   */
  function _editorHeader(pText) {
    const lHeader = $('<div class="ml_config_editor_header">').append($('<label>').text(pText));

    return lHeader;
  }

  /**
   * Renders the right view for the Controller configurator.
   * @param {Config} pConfig
   */
  function controllerSettings(pConfig, pConfigurationProps) {
    const lConfigManager = pConfig.getConfigManager();
    const lController = pConfig.getController();
    const lContainer = $('<div class="ml_controller_settings v_layout">');
    const lHostControllerLabel = $('<div>').text('You are plugged into this controller').addClass('ml_controller_plugged_in_indicator');

    $('<div>').append(
      $('<div>').append(
        $('<i>', { class: icons.define }),
        $('<label>').text("Controller Settings")
      ).addClass('ml_controller_settings_header__inner'),
      lHostControllerLabel
    ).addClass('ml_controller_settings_header').appendTo(lContainer);

    const lEditorContainer = $('<div class="ml_controller_settings_body v_layout">').appendTo(lContainer);
    const lInputContainer = $('<div>').addClass('ml_controller_settings_inputs').appendTo(lEditorContainer);

    function lGetControllerNameInput() {
      const lRequired = function (value) { return value ? undefined : 'This field is required'; };
      const lControllerName = widgets.stringWidget('Controller Name', 'The name of the controller', lController.getName(), function(pValue) {
        lController.setName(pValue);
      }, [lRequired], { labelTransformFunction: function(pLabel) { return pLabel; } });


      lControllerName.find('input').css('width', '427px');
      lControllerName.find('.ml_widget_label').css('font-size', '18px');

      return lControllerName;
    }

    function lGetIpAddressInput() {
      const lRequired = function (value) { return value ? undefined : 'This field is required'; };
      const lValidateIpAddress = function (value) { return lController.validateIpAddress(value).reason; };
      const lIpAddressContainer = $('<div>').css('position', 'relative');

      const lIpAddress = widgets.stringWidget('Controller IP Address', 'IP address of the controller', lController.getIpAddress(), function(pValue) {
        lController.setIpAddress(pValue);
      }, [lRequired, lValidateIpAddress], { labelTransformFunction: function(pLabel) { return pLabel; } });

      lIpAddress.find('input').css('width', '427px')
        .attr('type', 'tel').addClass('keyboard');

      lIpAddress.find('.ml_widget_label').css('font-size', '18px');

      const lIsOnlyController = lController.getConfig().mManager.getConfigurationList().length === 1;
      lIpAddress.find('input').attr('disabled', lIsOnlyController); // disable the ip address if there is only one controller.

      const lToolTipMessage = `
      <p><b>Where can I find my IP Address?</b></p>
      <p>You must first setup your network in the <b>network tab.</b> You can find this IP Address in your Automated System Diagrams (ASD).</p>
      <p>Then, return here to enter that IP Address.</p>
      `;

      const lToolTip = $('<div>').append(textToolTip("Where can I find this?", lToolTipMessage)).addClass('ml_controller_settings_input_tooltip');
      if(lIsOnlyController) { lToolTip.css('display', 'none'); }

      const lAvailabilityIndicator = $('<div>').addClass("ml_availability_indicator");
      const lErrorBox = $('<div>').css('width', '427px');
      const lConnectedIcon = $('<i>').addClass(icons.checkmark).css('color', '#1AC876');
      const lConnectedText = $('<span>').text('Connected').addClass('ml_availability_indicator_text');
      const lErrorIcon = $('<i>').addClass(icons.danger).css('color', '#D9534F');
      const lErrorMessage = $('<span>').attr('id', 'ip_availability_error_message').addClass('ml_input_validation_error').text("This controller is currently not reachable. Please verify your network setup and update your IP address.").hide();
      const lInput = lIpAddressContainer.find('input');

      lIpAddressContainer.append(
        lIpAddress.append(lAvailabilityIndicator),
        lToolTip,
        lErrorBox.append(lErrorMessage)
      );

      function lShowConnection() {
        lAvailabilityIndicator.empty();
        lAvailabilityIndicator.append(lConnectedIcon, lConnectedText);
        lInput.removeClass('ml_availability_input_error');
        lErrorMessage.hide();
      }

      function lShowConnectionError() {
        lAvailabilityIndicator.empty();
        lAvailabilityIndicator.append(lErrorIcon);
        lErrorMessage.show();
        lInput.addClass('ml_availability_input_error');
      }

      function lRemoveConnectionStatus() {
        lAvailabilityIndicator.empty();
        lErrorMessage.hide();
      }

      lInput.on('input', () => {
        lRemoveConnectionStatus();
      });

      lIpAddressContainer.showConnection = lShowConnection;
      lIpAddressContainer.showConnectionError = lShowConnectionError;
      lIpAddressContainer.removeConnectionStatus = lRemoveConnectionStatus;

      return lIpAddressContainer;
    }

    function textToolTip (pLabel, pTooltip) {
      const container = $('<div>').addClass('text-tooltip__container');
      const label = $('<span>').html(pLabel);
      const labelContainer = $('<button>').append(label).addClass('text-tooltip__label');
      const arrowLeft = $('<div>').addClass('text-tooltip__arrow-left');
      const toolTipContainer = $('<div>').html(pTooltip).addClass("text-tooltip__tooltip");

      toolTipContainer.append(arrowLeft);
      toolTipContainer.hide();

      container
        .on('mouseenter', () => {
          const toolTipContainerTop = (toolTipContainer.height() / -2);
          toolTipContainer.show();
          toolTipContainer.css('top', toolTipContainerTop);

        })
        .on('mouseleave', () => {
          toolTipContainer.hide();
        });

      container.append(
        labelContainer,
        toolTipContainer
      );

      return container;
    }

    function lGetHardwareVersionInput() {
      const lHardwareVersionList = lConfigManager.listAvailableHardwareVersions();
      const lWidget = widgets.listWidget('Controller Hardware Version', lHardwareVersionList, 'Hardware version of the controller', lController.getHardwareVersion(), function (pValue) {
        const maxDrives = lController.getNumberOfDrives(pValue);
        const occupiedDrives = lController.getConfig().getOccupiedDrives();
        if ( occupiedDrives.length > maxDrives ) {
          widgets.messageBox('The selected hardware version does not support the amount of drives currently configured. Your changes were reverted.', 'warning');
          lWidget.setValue(lController.getHardwareVersion()); // revert to the previous value
        }
        else if ( occupiedDrives.some ( driveNumber => { return driveNumber > maxDrives; } ) ) {
          widgets.messageBox('The selected hardware version does not support the currently configured DRIVE numbers. Your changes were reverted.', 'warning');
          lWidget.setValue(lController.getHardwareVersion()); // revert to the previous value
        }
        else {
          lController.setHardwareVersion(pValue);
        }

      }, undefined, function (pLabel) { return pLabel; });

      lWidget.removeClass('v_layout');
      lWidget.find('select').css('width', '427px');
      lWidget.find('div').eq(0).css('margin-bottom', '5px');
      lWidget.find('.h_layout > h5').css('font-size', '18px');

      return lWidget;
    }

    function lGetMakeParentBtn() {
      const lButton = $('<button>')
        .text('MAKE CONTROLLER PARENT')
        .addClass('ml_set_parent_controller_button')
        .on('click', () => {
          widgets.showConfirmationModal('Make this controller parent',
            'Please be aware that swapping this controller with the current parent controller may break your configuration.',
            () => {
              pConfig.getConfigManager().setParentController(pConfig.getController().getUUID());
              lButton.css('display', 'none');
            });
        });
      return lButton;
    }

    function lGetDeleteControllerBtn() {
      const lController = pConfig.getController();

      const lButton = $('<button>').addClass('ml_delete_controller_btn').append(
        $('<i>').addClass('far fa-trash').css({marginRight: '2px'}),
        $('<span>').text('Delete controller')
      ).on('click', () => {
        const lNumberOfInstructionsEffected = pConfig.mLibrary.getValidator().instructionsUsingController(lController).length;
        if (lNumberOfInstructionsEffected == 0) { lController.mManager.removeConfiguration(lController.getUUID()); }
        else {
          widgets.showConfirmationModal('Delete Controller', `This action will result in ${lNumberOfInstructionsEffected} invalid MachineLogic command${lNumberOfInstructionsEffected > 1 ? 's' : ''}.`,
            function() { lController.mManager.removeConfiguration(lController.getUUID()); });
        }
      });

      return lButton;
    }
    const lControllerNameInput = lGetControllerNameInput();
    const lIpAddressInput = lGetIpAddressInput();
    const lDeleteControllerBtn = lGetDeleteControllerBtn();
    const lMakeParentBtn = lGetMakeParentBtn();

    lInputContainer.append(lControllerNameInput);
    lInputContainer.append(lIpAddressInput);
    lInputContainer.append(lGetHardwareVersionInput());
    lInputContainer.append(lMakeParentBtn);
    lInputContainer.append(lDeleteControllerBtn);

    function lUpdateLabelsButtonsandIcons() {
      lHostControllerLabel.hide();

      if(!pConfigurationProps?.controllerProps?.hideNetworkSignifiers) {
        // Update Delete Controller Button
        const lHideDeleteButton = lController.isParent() || lController.isHost();
        lDeleteControllerBtn.css('display', lHideDeleteButton ? 'none' : 'block');

        // Update Make This Controller Parent Button
        const lHideMakeControllerParent = pConfig.getController().isParent() || !pConfig.getController().isHost() || !pConfig.mManager.getHostControllerUuid();
        lMakeParentBtn.css('display',  lHideMakeControllerParent ? 'none' : 'block');

        // Update Host Controller Label
        if(pConfig.getController().isHost()) { lHostControllerLabel.show(); }

        // Update Connection Indicators in IP Address Input
        switch (pConfig.getController().isAvailable()) {
          case true: {
            // To avoid confusion (as we internally patch to localhost when only a single controller), we will hide the IP UI
            if(pConfig.getConfigManager().getConfigurationList().length === 1) {
              lIpAddressInput.hide();
              break;
            }
            lIpAddressInput.showConnection();
            break;
          }
          case false: {
            lIpAddressInput.showConnectionError();
            break;
          }
          default: {
            lIpAddressInput.removeConnectionStatus();
            break;
          }
        }
      }
    }

    lUpdateLabelsButtonsandIcons();

    const lControllerListeners = {
      onNameChanged: function(pName) { lControllerNameInput.find('input').val(pName); },
    };

    const lConfigManagerListener = {
      onConfigDeployed: function() { lUpdateLabelsButtonsandIcons(); },
    };

    lController.addListener(lControllerListeners);
    pConfig.getConfigManager().addListener(lConfigManagerListener);
    lContainer.on('remove', () => {
      lController.removeListener(lControllerListeners);
      pConfig.getConfigManager().removeListener(lConfigManagerListener);
    });

    return lContainer;
  }

  /**
  * Renders the right view for the All Configurations View.
  * @param {Config} pConfig
  */
  function allConfigurationView(pConfigManager) {
    const lContainer = $('<div class="ml_scrollable v_layout">').css({height: '100%', overflow: 'hidden auto'});
    const lEditorHeader = _editorHeader('All configurations').css('justify-content', 'space-between');
    lEditorHeader.append( $('<div>').text('READ ONLY').css({fontWeight: '400', color: '#667A99', fontSize: '15px'}) );
    const lOverviewContainer = $('<div>').addClass('ml_config_overview v_layout');

    // Create the overview container
    const lAxisOverviewList = $('<div>')
      .addClass('ml_config_overview_list')
      .append(...pConfigManager.listAxes().map( pAxis => [
        $('<span>').text(pAxis.getConfig().getController().getFormattedName()),
        $('<span>').text(pAxis.getName()),
        $('<span>').text(helpers.formatAxisType(pAxis.getType()))
      ]
      ));

    const lAxisOverviewContainer = $('<div>').append(
      $('<label>').text('Actuators'),
      lAxisOverviewList
    );

    const lInputOverviewList = $('<div>')
      .addClass('ml_config_overview_list')
      .append(...pConfigManager.listInputs().map(pInput => [
        $('<span>').text(pInput.getConfig().getController().getFormattedName()),
        $('<span>').text(pInput.getName()),
        $('<span>').text(formatModuleType(pInput.getDeviceType()))
      ]
      ));
    const lInputOverviewContainer = $('<div>').append(
      $('<label>').text('Inputs'),
      lInputOverviewList
    );

    const lOutputOverviewList = $('<div>')
      .addClass('ml_config_overview_list')
      .append(...pConfigManager.listOutputs().map( pOutput => [
        $('<span>').text(pOutput.getConfig().getController().getFormattedName()),
        $('<span>').text(pOutput.getName()),
        $('<span>').text(formatModuleType(pOutput.getDeviceType()))
      ]
      ));
    const lOutputOverviewContainer = $('<div>').append(
      $('<label>').text('Outputs'),
      lOutputOverviewList
    );

    lContainer.append(
      lEditorHeader,
      $('<div>').append(
        lOverviewContainer.append(
          lAxisOverviewContainer,
          lInputOverviewContainer,
          lOutputOverviewContainer
        )
      )
    );

    return lContainer;
  }


  function showApplicationCheckerHintCard(pNavigate, pConfig, pWidget) {
    const lUrl = window.location;
    const urlParams = new URLSearchParams(lUrl.search);
    if(!urlParams.has('warning'))     { return; }
    if(!environment.isOnConfigPage()) { return; }
    if(!environment.isOnPendant())    { return; }

    // Show Error Handling message, if we arrived from Machine Logic via `target = redirect-config`
    // this is a almost an exact copy of the assembler version
    const _lShowErrorCard = function(pData) {
      if (!pData) {
        return;
      }

      $('.ml_validator_error_card').remove();
      const lCard = $('<div class="ml_validator_error_card" id="ml_validator_config_card">')
        .append(
          $('<div id="title">').text(pData.header).css({'font-size': '20px'}),
          $('<div>').text(pData.source),
          $('<div>').text('Ways to fix warning:'),
          $('<div>').text(pData.suggestion),
          $('<button class="ml_close ml_close_card_widget h_layout spaced">')
            .click(function() {
              $('#ml_validator_config_card').remove();
              // Remove the error handling trace from the url
              pNavigate(lUrl.pathname, { replace: true });
            }),
          // go to machine logic
          $('<button class="ml_validator_go_back_button">')
            .text('I fixed this, back to MachineLogic >')
            .css({ 'text-decoration': 'underline', 'padding-top': '10px', 'font-size': '18px'})
            .click(() => pNavigate("/machine-logic")),
        )
        .css({
          'background': 'white',
          'border': 'solid 1px #CBCFD6',
          'border-radius': '5px',
          'box-shadow': '0px 0px 30px 0px #999',
          'position': 'absolute',
          'bottom': '50px',
          'right': '55px',
          'width': '325px',
        });

      // red badge
      lCard.find('#title').prepend(
        $('<span class="ml_validator_badge_ml">').css({ 'position': 'relative','top': '-5px','left': '-5px'})
          .append($('<span class="fas fa-exclamation">').css({'color': 'white', 'font-size': '8px'}))
      );

      lCard.appendTo('#guiContainer');
    };

    // The Error Handling message, if present, is encoded in the URL parameter
    if (urlParams.has('warning')) {
      _lShowErrorCard(JSON.parse(urlParams.get('warning')));
    }
  }

  /**
   * Creates the actuator editor page.
   * @param {Navigate} pNavigate
   * @param {machinelogic.Config} pConfig
   * @param pIsReadonly
   * @param pActuatorProps
   * @returns {JQuery}
   */
  function actuatorEditor(pNavigate, pConfig, pIsReadonly, pActuatorProps) {
    const lContainer = $('<div class="ml_group v_layout spaced">');
    const lHeader = _editorHeader('Actuators').appendTo(lContainer).addClass('h_layout').css('justify-content', 'space-between');
    const lAxes = $('<div class="ml_axes ml_group v_layout spaced">').attr('id', 'ml_active_config_list').appendTo(lContainer);
    const lAxesHeaderSettingsButton =  $('<button>', {
      class: "ml_drive_settings_menu_button ml_drive_header", html: `<span> <span class="${icons.define}"/> <span> Drive Settings </span> </span>`, click: function() {
        showDriveSettingsModal(pConfig);
      }
    }).appendTo(lHeader);

    if(pIsReadonly) {
      lAxesHeaderSettingsButton.attr('disabled', 'disabled');
      lAxesHeaderSettingsButton.css({'cursor': 'default'});
    }

    let lCCButton;

    const lOpenConfigCheckerResultsPage = function() {
      const lConfigManager = pConfig.mManager;
      if( lConfigManager && lConfigManager.mDirty ) {
        showApplyConfigurationModal(
          () => lConfigManager.deploy(
            // TODO GD This code should ultimately live in the pendant. The VSE should not be aware of the pendant routes
            () => pNavigate({ pathname: "/check-config", search: `?controllerId=${pConfig.getController().getUUID()}` })
          ),
          // TODO GD This code should ultimately live in the pendant. The VSE should not be aware of the pendant routes
          () => {
            lConfigManager.revertChangesToLastSave();
            pNavigate({ pathname: "/check-config", search: `?controllerId=${pConfig.getController().getUUID()}` });
          }
        );

        return;
      }

      // TODO GD This code should ultimately live in the pendant. The VSE should not be aware of the pendant routes
      pNavigate({ pathname: "/check-config", search: `?controllerId=${pConfig.getController().getUUID()}` });
    };

    const enableDisableCCButton = function() {
      // greyout the button if we have some not applied configuration changes
      if (lCCButton) {
        const lIsDisabled = pConfig.getConfigManager().mDirty;
        lCCButton.toggleClass('disabled', lIsDisabled);
      }
    };

    if (!pActuatorProps?.disableConfigChecker) {
      lCCButton = $('<div>').text('Configuration Checker Status & Past Results')
        .addClass('ml_config_checker_status_button')
        .on('click', lOpenConfigCheckerResultsPage);

      enableDisableCCButton();
      if(pIsReadonly) { lCCButton.addClass('disabled'); lCCButton.off('click'); }
    }

    const lSetAxesNumbers = function() {
      pConfig.listAxes().forEach(function(pAxis) {
        const lAxisCard = lAxes.find('#axis_' + pAxis.getUUID());
        lAxisCard.find('.ml_number').text(pAxis.getAxisLabel());
      });
    };
    const updateButtons = function() {
      // hide the drive settings and do not display the config checker unless it's the pendant
      if (!pActuatorProps?.hideDriveSettings) {
        // hide or show the buttons based on the number of real axis present
        if(pConfig.numberOfRealAxes()) {
          lAxesHeaderSettingsButton.show();
          if (lCCButton) {
            // Hide the button if the controller is unavaliable
            pConfig.getController().isAvailable() ? lCCButton.show() : lCCButton.hide();
          }
        } else {
          lAxesHeaderSettingsButton.hide();
          if (lCCButton) lCCButton.hide();
        }
      }
      else {
        lAxesHeaderSettingsButton.hide();
      }
    };

    const lAxisWidgetFunc = pActuatorProps?.overrideWidget ?? ((pConfig, pAxis) => axisConfigCard(pNavigate, pConfig, pAxis));
    const lRender = function() {
      // Render the axes first
      lAxes.empty();
      if(!pIsReadonly && lCCButton) { lCCButton.off().on('click', lOpenConfigCheckerResultsPage); }
      if(pConfig.numberOfAxes() && lCCButton) { lAxes.prepend(lCCButton); }

      updateButtons();

      pConfig.listAxes().forEach(function(pAxis) {
        const lWidget = lAxisWidgetFunc(pConfig, pAxis, pIsReadonly);
        lAxes.append(lWidget);
      });

      lSetAxesNumbers();
    };
    const lConfigListener = {
      onAxisAdded: function(pAxis) {
        // Note (AJ): This block of code is just for the autoscroll to added axis functionality.
        // When a axis gets added the the axisList gets sorted which re-renders all the axis widgets
        // in order by calling lRender
        const lWidget = lAxisWidgetFunc(pConfig, pAxis);
        lAxes.append(lWidget);
        lWidget[0].scrollIntoView();
      },
      onAxisRemoved: function() { updateButtons(); },
      maxNumberOfAxesReached: function() {
        widgets.messageBox('Reached limit number of axes', 'warning');
      },
      onAxesSorted: function() {
        !pActuatorProps?.disableRerender && lRender();
      }
    };
    const lConfigManagerListener = {
      onSetDirty: enableDisableCCButton,
      onConfigDeployed: enableDisableCCButton
    };

    // Rendering done here
    lRender();

    // Listener logic
    pConfig.addListener(lConfigListener);
    pConfig.getConfigManager().addListener(lConfigManagerListener);
    lContainer.on('remove', function onRemoveConfigDocument() {
      pConfig.removeListener(lConfigListener);
      pConfig.getConfigManager().removeListener(lConfigManagerListener);
    });

    return lContainer;
  }

  /**
   * Creates the editor editor page.
   * @param {machinelogic.Config} pConfig
   * @returns {JQuery}
   */
  function robotEditor(pConfig, pIsReadonly) {
    const lContainer = $('<div class="ml_group v_layout spaced">').append(_editorHeader('Robots'));
    const lRobots = $('<div class="ml_robots ml_group v_layout spaced">').attr('id', 'ml_active_config_list').appendTo(lContainer);

    const lRobotWidgetFunc = robotWidget;

    const lRender = function () {
      // Render the robots first
      lRobots.empty();
      pConfig.listRobots().forEach(function (pRobot) {
        const lWidget = lRobotWidgetFunc(pConfig, pRobot);
        lRobots.append(lWidget);
      });
    };
    const lConfigListener = {
      onRobotAdded: function (pRobot) {
        // Note (AJ): This block of code is just for the autoscroll to added robot functionality.
        // When a robot gets added the the robotList gets sorted which re-renders all the robot widgets
        // in order by calling lRender
        const lWidget = lRobotWidgetFunc(pConfig, pRobot);
        lRobots.append(lWidget);
        lWidget[0].scrollIntoView();
      },
    };

    // Rendering done here
    lRender();

    // Listener logic
    pConfig.addListener(lConfigListener);
    lContainer.on('remove', function onRemoveConfigDocument() {
      pConfig.removeListener(lConfigListener);
    });

    return lContainer;
  }

  /**
   * Creates the input page.
   * @param {machinelogic.Config} pConfig
   * @returns {JQuery}
   */
  function inputEditor(pConfig, pInputProps) {
    const lContainer = $('<div class="ml_group v_layout spaced">').append(_editorHeader('Inputs'));
    const lInputs = $('<div class="ml_inputs ml_group v_layout spaced">').attr('id', 'ml_active_config_list').sortable({
      axis: 'y',
      distance: 4,
      tolerance: 'pointer',
      containment: '.ml_inputs',
      start : function(pEvent, pUi) {
        lInputFrom = pUi.item.index();
      },
      update: function(pEvent, pUi) {
        lInputTo = pUi.item.index();
        pConfig.moveInput(lInputFrom, lInputTo);
      }
    }).appendTo(lContainer);
    let lInputFrom;
    let lInputTo;
    const lInputWidgetFunc = pInputProps?.overrideWidget ?? inputWidget;
    const lAddInput = function(pInput) {
      const _lWidget = lInputWidgetFunc(pConfig, pInput);
      lInputs.append(_lWidget);
      _lWidget[0].scrollIntoView();
    };
    const lRender = function() {
      lInputs.empty();
      pConfig.listInputs().forEach(function(pInput) {
        lAddInput(pInput);
      });
    };
    const _lConfigListener = {
      onInputAdded: lAddInput,
      onInputMoved: function(pFrom, pTo) {
        // UI has already been sorted manually
        if(pFrom == lInputFrom && pTo == lInputTo) {
          lInputFrom = undefined;
          lInputTo = undefined;
        } else {
          if(pTo == 0) {
            lInputs.prepend($(lInputs.children().get(pFrom)));
          } else if(pFrom > pTo){
            $(lInputs.children().get(pFrom)).insertAfter($(lInputs.children().get(pTo - 1)));
          } else {
            $(lInputs.children().get(pFrom)).insertAfter($(lInputs.children().get(pTo)));
          }
          lInputs.children().get(pTo).scrollIntoView();
        }
      }
    };

    // Rendering done here
    lRender();

    // Listener logic
    pConfig.addListener(_lConfigListener);
    lContainer.on('remove', function onRemoveConfigDocument() {
      pConfig.removeListener(_lConfigListener);
    });

    return lContainer;
  }

  /**
   * Creates the output page.
   * @param {machinelogic.Config} pConfig
   * @returns {JQuery}
   */
  function outputEditor(pConfig, pOutputProps) {
    const lContainer = $('<div class="ml_group v_layout spaced">').append(_editorHeader('Outputs'));
    const lOutputs = $('<div class="ml_outputs ml_group v_layout spaced">').attr('id', 'ml_active_config_list').sortable({
      axis: 'y',
      distance: 4,
      tolerance: 'pointer',
      containment: '.ml_outputs',
      start : function(pEvent, pUi) {
        lOutputFrom = pUi.item.index();
      },
      update: function(pEvent, pUi) {
        lOutputTo = pUi.item.index();
        pConfig.moveOutput(lOutputFrom, lOutputTo);
      }
    }).appendTo(lContainer);
    let lOutputFrom;
    let lOutputTo;
    const lOutputWidgetFunc = pOutputProps?.overrideWidget ?? outputWidget;
    const lAddOutput = function(pOutput) {
      const _lWidget = lOutputWidgetFunc(pConfig, pOutput);
      lOutputs.append(_lWidget);
      _lWidget[0].scrollIntoView();
    };
    const lRender = function() {
      lOutputs.empty();
      pConfig.listOutputs().forEach(function(pOutput) {
        lAddOutput(pOutput);
      });
    };
    const _lConfigListener = {
      onOutputAdded: lAddOutput,
      onOutputMoved: function(pFrom, pTo) {
        // UI has already been sorted manually
        if(pFrom == lOutputFrom && pTo == lOutputTo) {
          lOutputFrom = undefined;
          lOutputTo = undefined;
        } else {
          if(pTo == 0) {
            lOutputs.prepend($(lOutputs.children().get(pFrom)));
          } else if(pFrom > pTo){
            $(lOutputs.children().get(pFrom)).insertAfter($(lOutputs.children().get(pTo - 1)));
          } else {
            $(lOutputs.children().get(pFrom)).insertAfter($(lOutputs.children().get(pTo)));
          }
          lOutputs.children().get(pTo).scrollIntoView();
        }
      }
    };

    // Rendering done here
    lRender();

    // Listener logic
    pConfig.addListener(_lConfigListener);
    lContainer.on('remove', function onRemoveConfigDocument() {
      pConfig.removeListener(_lConfigListener);
    });

    return lContainer;
  }

  function formatModuleType(moduleType) {
    switch(moduleType) {
      case "digitalIOModule"                       : return "Digital IO";
      case "pushButtonModule"                      : return "Push Button";
      case "powerSwitchModule"                     : return "Power Switch";
      default                                      : return moduleType;
    }
  }

  function robotWidget(pConfig, pRobot) {
    let robotConfigWidget;

    function machineBuilderRobotCloseButtonClicked(
      pConfig,
      pRobot
    ) {
      return () => {
        pConfig.removeRobotWithVID(pRobot.getVID());
      };
    }

    function createControlCenterRobotConfigWidget({
      robotTypes,
      closeButtonClicked,
    }) {
      const onClose = function (widget) {
        closeButtonClicked();
        ReactDOM.unmountComponentAtNode(robotConfigWidget);
        widget.remove();
        pConfig.removeRobotInControlCenter();
      };

      robotConfigWidget && ReactDOM.unmountComponentAtNode(robotConfigWidget);

      const _lWidget = widgets.card('', () => { });
      _lWidget.css({ padding: '4px 16px 4px 4px' });
      _lWidget.icon.empty().removeClass().addClass('ml_config_card_label').append( $('<div> Robot </div>'));
      _lWidget.icon.css({ marginRight: '16px', fontSize: '16px' });
      robotConfigWidget = _lWidget.find('.ml_parameters')[0];
      $(robotConfigWidget).css({ gridTemplateColumns: '[col] 1fr [col] 1fr [col] 1fr' });
      _lWidget.blockOnClose();
      _lWidget.close.click(() => onClose(_lWidget));

      ReactDOM.render(
        React.createElement(ControlCenterRobotConfigWidget, {
          robotTypes,
          config: pConfig
        }),
        robotConfigWidget
      );

      robotConfigWidgets.push(robotConfigWidget);

      return _lWidget;
    }

    function createMachineBuilderRobotConfigWidget({
      p3DContext,
      robotVID,
      closeButtonClicked
    }) {
      robotConfigWidget && ReactDOM.unmountComponentAtNode(robotConfigWidget);

      const _lWidget = widgets.card('', () => { });
      _lWidget.removeClass().addClass('ml_config_card');
      _lWidget.icon.empty().removeClass().addClass('ml_config_card_label').append( $('<div> Robot </div>'));
      _lWidget.icon.css({ marginRight: '16px', fontSize: '16px' });
      _lWidget.close.removeClass().addClass('ml_config_card_close_button').append("x");
      robotConfigWidget = _lWidget.find('.ml_parameters')[0];
      const onRobotRemoved = () => {
        ReactDOM.unmountComponentAtNode(robotConfigWidget);
        _lWidget.remove();
      };
      const onClose = async function (widget) {
        closeButtonClicked();
        ReactDOM.unmountComponentAtNode(robotConfigWidget);
        widget.remove();
      };
      _lWidget.blockOnClose();
      _lWidget.close.click(() => onClose(_lWidget));
      p3DContext.registerForNotification('robot_removed', onRobotRemoved);

      ReactDOM.render(
        React.createElement(MachineBuilderRobotConfigWidget, {
          p3DContext,
          pConfig,
          robotVID
        }),
        robotConfigWidget
      );

      return _lWidget;
    }

    return environment.isOnPendant()
      ? createControlCenterRobotConfigWidget({
        robotTypes:
            pConfig.mLibrary.mInstructionSet.config.robot.parameters.find(
              (paramObj) => /robotType/i.test(paramObj.name)
            ).values,
        closeButtonClicked: () => {},
      })
      : createMachineBuilderRobotConfigWidget({
        robotVID: pRobot.mVID,
        p3DContext: pRobot.m3DContext,
        closeButtonClicked: machineBuilderRobotCloseButtonClicked(
          pConfig,
          pRobot
        ),
      });
  }

  function inputWidget(pConfig, pInput) {
    const _lWidget = widgets.card(icons.input, function() { pConfig.removeInput(pInput); },
      {
        title: `Delete Input`,
        getMessage: function() {
          const lNumberOfInstructionsEffected = pConfig.mLibrary.getValidator().instructionsUsingInputsOutputs('Input', pInput).length;
          if (lNumberOfInstructionsEffected != 0) { return `This action will result in ${lNumberOfInstructionsEffected} invalid MachineLogic command${lNumberOfInstructionsEffected > 1 ? 's' : ''}.`; }
          return null;
        }
      }).addClass('ml_input');
    const _lName = widgets.stringWidget('Name', 'Input name', pInput.getName(), function(pName) {
      pInput.setName(pName);
    });
    const _lModule = widgets.listWidget(
      'Module Type',
      [{value: 'digitalIOModule', text: 'Digital IO'}, {value: "pushButtonModule", text: 'Push Button'}],
      'Input device',
      pInput.getDeviceType(),
      function(pValue) {
        const success = pInput.setDeviceType(pValue);
        if (!success) {
          _lModule.setValue(pInput.getDeviceType());
          widgets.messageBox("Cannot add a new " + widgets.camelCaseToText(pValue) + " to the configuration. Your changes have been reverted.", "warning");
        }
      }
    );
    const _lDevice = widgets.listWidget('Device', pInput.getDeviceRange(), 'Input device', pInput.getDevice(), function(pValue) {
      pInput.setDevice(parseInt(pValue));
    });
    const _lPin = widgets.listWidget('Pin', pInput.getPinRange(), 'Input pin', pInput.getPin(), function(pValue) {
      pInput.setPin(parseInt(pValue));
    });
    const _lColor = widgets.listWidget('Color', [{value: '0', text: 'Black'}, {value: "1", text: 'White'}], 'Push button color', pInput.getPin(), function(pValue) {
      pInput.setPin(parseInt(pValue));
    });
    const _lInputListener = {
      onDeviceChanged: function(pDevice) {
        _lDevice.setValue(pDevice);
      },
      onPinChanged: function(pPin) {
        if (pInput.getDeviceType() == 'pushButtonModule') {
          _lColor.setValue(pPin);
        } else {
          _lPin.setValue(pPin);
        }
      },
      onTypeChanged: function(pType) {
        _lDevice.setValue(pInput.getDevice());
        if (pType == 'pushButtonModule') {
          _lPin.detach();
          _lWidget.parameters.append(_lColor);
          _lColor.setValue(pInput.getPin());
        } else {
          _lColor.detach();
          _lWidget.parameters.append(_lPin);
          _lPin.setValue(pInput.getPin());
        }
      },
      onNameChanged:function(pName) {
        _lName.children('input').val(pName);
      }
    };
    const _lConfigListener = {
      onIOMapUpdate: disableUnavailablePins,
    };

    // attach listeners
    pInput.mConfig.addListener(_lConfigListener);
    pInput.addListener(_lInputListener);

    _lWidget.parameters.append(_lName, _lModule, _lDevice, pInput.getDeviceType() == 'pushButtonModule' ? _lColor : _lPin);

    // clean up listeners
    _lWidget.on('remove', function onInputWidget() {
      pInput.mConfig.removeListener(_lConfigListener);
      pInput.removeListener(_lInputListener);
    });

    function disableUnavailablePins() {
      widgets_helper.disableUsedPins({
        inputWidgetList: [_lColor, _lPin],
        outputWidgetList: [],
        config: pInput.mConfig,
        device: pInput.getDevice(),
      });
      widgets_helper.disableDevices({
        controlModuleWidget: _lDevice,
        config: pInput.mConfig,
        minAvailablePins: 1,
        checkType: 'input',
        deviceType: pInput.getDeviceType(),
      });
    }

    disableUnavailablePins();

    return _lWidget;
  }

  function outputWidget(pConfig, pOutput) {
    const _lWidget = widgets.card(icons.output, function() { pConfig.removeOutput(pOutput); },
      {
        title: `Delete Output`,
        getMessage: function() {
          const lNumberOfInstructionsEffected = pConfig.mLibrary.getValidator().instructionsUsingInputsOutputs('Output', pOutput).length;
          if (lNumberOfInstructionsEffected != 0) { return `This action will result in ${lNumberOfInstructionsEffected} invalid MachineLogic command${lNumberOfInstructionsEffected > 1 ? 's' : ''}.`; }
          return null;
        }
      }).addClass('ml_output');
    const _lName = widgets.stringWidget('Name', 'Output name', pOutput.getName(), function(pName) {
      pOutput.setName(pName);
    });
    const _lModule = widgets.listWidget(
      'Module Type',
      [{value: 'digitalIOModule', text: 'Digital IO'}, {value: "powerSwitchModule", text: 'Power Switch'}],
      'Output device',
      pOutput.getDeviceType(),
      function(pValue) {
        const success = pOutput.setDeviceType(pValue);
        if (!success) {
          _lModule.setValue(pOutput.getDeviceType());
          widgets.messageBox("Cannot add a new " + widgets.camelCaseToText(pValue) + " to the configuration. Your changes have been reverted.", "warning");
        }
      }
    );
    const _lDevice = widgets.listWidget('Device', pOutput.getDeviceRange(), 'Output device', pOutput.getDevice(), function(pValue) {
      pOutput.setDevice(parseInt(pValue));
    });
    const _lPin = widgets.listWidget('Pin', pOutput.getPinRange(), 'Output pin', pOutput.getPin(), function(pValue) {
      pOutput.setPin(parseInt(pValue));
    });
    const _lOutputListener = {
      onDeviceChanged: function(pDevice) {
        _lDevice.setValue(pDevice);
      },
      onPinChanged: function(pPin) {
        _lPin.setValue(pPin);
      },
      onTypeChanged: function(pType) {
        _lDevice.setValue(pOutput.getDevice());
        if (pType == 'digitalIOModule') {
          _lWidget.parameters.append(_lPin);
        } else {
          _lPin.detach();
        }
      },
      onNameChanged:function(pName) {
        _lName.children('input').val(pName);
      }
    };
    const _lConfigListener = {
      onIOMapUpdate: disableUnavailablePins,
    };

    // attach listeners
    pOutput.mConfig.addListener(_lConfigListener);
    pOutput.addListener(_lOutputListener);

    _lWidget.parameters.append(_lName, _lModule, _lDevice);
    if ( pOutput.getDeviceType() == 'digitalIOModule' ) { _lWidget.parameters.append(_lPin); }

    // clean up listeners
    _lWidget.on('remove', function onRemoveOutputWidget() {
      pOutput.mConfig.removeListener(_lConfigListener);
      pOutput.removeListener(_lOutputListener);
    });

    function disableUnavailablePins() {
      widgets_helper.disableUsedPins({
        inputWidgetList: [],
        outputWidgetList: [_lPin],
        config: pOutput.mConfig,
        device: pOutput.getDevice(),
      });
      widgets_helper.disableDevices({
        controlModuleWidget: _lDevice,
        config: pOutput.mConfig,
        minAvailablePins: 1,
        checkType: 'output',
        deviceType: pOutput.getDeviceType(),
      });
    }

    disableUnavailablePins();

    return _lWidget;
  }

  function showDriveSettingsModal(pConfig, pCCErrorMsg) { // Note(AJ): do NOT remove pCCErrorMsg, it in used by the mm-pendant repo for configchecker
    const lMakeInstructionTooltip = function(key) {
      return $('<span class="ml_tooltip_icon ml_label_icon ' + icons.unknown + '"/>').click(
        function () {
          tooltips.showTips(key);
        }
      );
    };
    // Opens up the drive selector. Check this design for more details: https://projects.invisionapp.com/share/3BZ0T2YVY64#/screens/435254202
    const lModalContainer = $('<div>', { class: 'ml_modal_container' }).appendTo('body');
    const lModal = $('<div>', { class: 'ml_modal ml_drive_selector_modal' }).appendTo(lModalContainer);
    const lContentContainer = $('<div>').appendTo(lModal);
    const lHeader = $('<div>', { class: 'ml_modal_header ml_drive_selector_header', text: "Assign & Synchronize Drives" }).css({display: 'flex', justifyContent: 'center'}).appendTo(lContentContainer);

    if (pCCErrorMsg) {
      const lAddMessage = (msg) => {
        lContentContainer.append($('<div>').text(msg).css({textAlign: 'center', fontSize: '14px'}));
      };

      if (Array.isArray(pCCErrorMsg)) { pCCErrorMsg.forEach(msg => { lAddMessage(msg); }); }
      else { lAddMessage(pCCErrorMsg); }
    }

    lHeader.append(lMakeInstructionTooltip('assign_drive_title').css({paddingTop: '5px'}));
    const lFooter = $('<div>', { class: 'ml_modal_footer' }).appendTo(lModal);
    const lDriveRow = $('<div>', { class: 'ml_drive_selector' }).appendTo(lContentContainer);
    const lAxisOptionUi = [];
    let lAxisToDriveMapOnCreation = [];
    const updateAxes = function(pAxisParams) {
      // pAxisParams looks like this : [...{uuid: XXX, direction: 1, parent: true, colorIndex: 0}...]
      const lNewConfig = {};

      // Sort the parameters so that we can guarantee that parents are always first
      pAxisParams.sort(function(pFirst, pSecond) {
        if (pFirst.uuid != pSecond.uuid) {
          return pFirst.colorIndex - pSecond.colorIndex;
        } else {
          return pFirst.parent ? -1 : 1;
        }
      });

      // We will process parents first so they can have some children   ;)
      pAxisParams.filter(function(pAxisParam) { return pAxisParam.parent; })
        .forEach(function(pAxisParam) {
          lNewConfig[pAxisParam.uuid] = {
            colorIndex: pAxisParam.colorIndex,
            direction: pAxisParam.direction,
            children: []
          };
        });

      pAxisParams.filter(function(pAxisParam) { return !pAxisParam.parent; })
        .forEach(function(pAxisParam) { lNewConfig[pAxisParam.uuid].children.push(pAxisParam);});

      // The color indexes in the loop belows are in the range [0, 3].
      // We can use them to access the mAxisColors array directly.
      Object.keys(lNewConfig).forEach(function(pAxisUUid) {
        const lNewAxisConfig = lNewConfig[pAxisUUid];
        const lAxis = pConfig.getAxisByUuid(pAxisUUid);
        lAxis.setColor(pConfig.getColors()[lNewAxisConfig.colorIndex]);
        lAxis.setRotation(lNewAxisConfig.direction);
        lAxis.clearChildDrives();

        lNewAxisConfig.children.forEach(function(pChild) {
          lAxis.addChildDrive(pConfig.getColors()[pChild.colorIndex], pChild.direction);
        });
      });

      pConfig.sortAxes();
      pConfig.setDirty();
    };
    const validateAxesCombine = function(start, end) {
      function makeSentence(pArray) {
        if(pArray.length == 1) { return pArray.join(''); }
        else if(pArray.length == 2) { return pArray.join(' and '); }
        return pArray.slice(0, pArray.length - 1).join(', ') + " and " +  pArray[pArray.length - 1];
      }

      if(JSON.stringify(start) === JSON.stringify(end)) { return { 'success' : 'No changes.'}; }

      // remove duplicates uuids, so we can catch if we lost some in the process
      const lUuidsStart = start
        .map(function(pEl) { return pEl.uuid; })
        .filter(function(pItem, pPos, self) { return self.indexOf(pItem) == pPos; });
      const lUuidsEnd = end
        .map(function(pEl) { return pEl.uuid; })
        .filter(function(pItem, pPos, self) { return self.indexOf(pItem) == pPos; });

      // handle missing name
      if(lUuidsStart.length > lUuidsEnd.length) {
        const lMissingUuid = lUuidsStart.filter(function(el) { return !lUuidsEnd.includes(el); });
        const lMissingName = lMissingUuid.map(function(pMissingUuid){return pConfig.getAxisByUuid(pMissingUuid).getName();});
        return { 'error' : `Actuator ${lMissingName} not assigned to a Drive.` };
      }

      // NOTE: this might not be needed as there is logic that always makes one parent, but we will keep it in case.
      // verify that we have only one parent per axis by building a Counter ({X: 1, y:2, Z:0 ... })
      const lParentMap = end.reduce(function (pAccumulator, pCurrent) {
        if (!(pCurrent.uuid in pAccumulator)) { pAccumulator[pCurrent.uuid] = 0; }
        if(pCurrent.parent) { pAccumulator[pCurrent.uuid]++; }
        return pAccumulator;
      }, {});

      // and then verity that count for each is 1
      const lErrors = [];
      for(const key in lParentMap ) { if (lParentMap[key] != 1) { lErrors.push(key); }}

      if(lErrors.length) {
        return { 'error' : `${lErrors.length == 1 ? 'Axis' : 'Axes'} ${makeSentence(lErrors)} should have only one parent.`};
      }

      return { 'update' : `Updating configuration ...` };
    };
    const makeAxisDriveMap = function() {
      const lAxisDriveMap = lAxisOptionUi
        .map(function(el, i) {
          const lNameSelect       = el.name[0].options;
          const lUuid             = lNameSelect[lNameSelect.selectedIndex].value;
          const lDirection        = parseInt(el.direction.val());
          const lParent           = el.parentCheckbox.find('input').is(':checked');
          return { uuid:lUuid, direction:lDirection, parent:lParent, colorIndex: i };
        })
        .filter(function(el) { return el.uuid != '-1'; /* drop the unassigned drives */ });
      return lAxisDriveMap;
    };
    const lPopulateModal = function() {
      const lAxes = pConfig.listAxes().filter(function(pAxis) { return !pAxis.isNonMotorized(); });
      const lIsOneDrive = pConfig.maxNumberOfAxes() == 1;

      for (let lColorIndex = 0; lColorIndex < pConfig.maxNumberOfAxes(); lColorIndex++) {
        let lCurrentAxis = null;

        const lElement = $('<div>', { class: 'ml_drive_selector_element'}).appendTo(lDriveRow);
        $('<label>', { text: 'DRIVE ' + (lColorIndex + 1)}).appendTo(lElement);
        const imgSrc = environment.isOnPendant() ? '/vse/images/drive.png' : `https://ventionblobs.s3.amazonaws.com/machine-cloud/machine-motion/drive.png`;
        $('<img>', { src: imgSrc}).appendTo(lElement);

        const makeAtLeastOneDriveParent = function() {
          const lNameParentMap = {};
          // make a map  { name : parent-qty }
          lAxisOptionUi.forEach(function(el) {
            const lName = el.name[0].options[el.name[0].options.selectedIndex].innerText;
            if(lName == 'Unassigned') { return; }
            if(!lNameParentMap[lName]) { lNameParentMap[lName] = 0; }
            if( el.parentCheckboxTop.find('input').is(':checked')) { lNameParentMap[lName] += 1; }
          });

          // find orphans and set parent
          for (const n in lNameParentMap) {
            if(lNameParentMap[n]) { continue; }

            // find the ui element with the same name
            const lFound = lAxisOptionUi.filter(function(el) { return n == el.name[0].options[el.name[0].options.selectedIndex].innerText; });

            // set as parent, for simplicity we will select the first items, because we need to pick one
            lFound[0].parentCheckbox.trigger('set_checked', true);
            lFound[0].parentCheckbox.trigger('set_disabled', true);
            lFound[0].parentCheckboxTop.addClass('ml_drive_selector_unassigned');
          }
        };

        const lCreateOnNameChange = function(pDriveIdx) {
          return function() {
            // switching to Unassigned, why parent? not important, as long as it is predictable
            if(lAxisOptionUi[pDriveIdx].name.val() == -1) {
              lAxisOptionUi[pDriveIdx].name.addClass('ml_drive_selector_unassigned');
              lAxisOptionUi[pDriveIdx].direction.addClass('ml_drive_selector_unassigned');
              lAxisOptionUi[pDriveIdx].direction.prop('disabled', true);
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_checked', true);
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_disabled', true);
              lAxisOptionUi[pDriveIdx].parentCheckboxTop.addClass('ml_drive_selector_unassigned');

              makeAtLeastOneDriveParent();
              return;
            }

            lAxisOptionUi[pDriveIdx].name.removeClass('ml_drive_selector_unassigned');
            lAxisOptionUi[pDriveIdx].direction.removeClass('ml_drive_selector_unassigned');
            lAxisOptionUi[pDriveIdx].direction.prop('disabled', false);

            if(lAxisOptionUi.filter(function(pUi) { return pUi.name.val() == lAxisOptionUi[pDriveIdx].name.val(); }).length > 1) {
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_checked', false);
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_disabled', false);
              lAxisOptionUi[pDriveIdx].parentCheckboxTop.removeClass('ml_drive_selector_unassigned');
            } else {
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_checked', true);
              lAxisOptionUi[pDriveIdx].parentCheckbox.trigger('set_disabled', true);
              lAxisOptionUi[pDriveIdx].parentCheckboxTop.addClass('ml_drive_selector_unassigned');
            }
            makeAtLeastOneDriveParent();
          };
        };

        // Actuator Names
        const lActuatorSelector = widgets.select('Drive ' + (lColorIndex + 1));
        const lSelectElement = lActuatorSelector.getSelect();

        lSelectElement.val(-1);
        lSelectElement.change(lCreateOnNameChange(lColorIndex));
        if(lIsOneDrive) {
          // for one-drive has greyed out actuator name and parent (parent is greyout automaticaly, because no children)
          lActuatorSelector.addClass('ml_select_greyout_chevron');
          lSelectElement.prop('disabled', true);
          lSelectElement.addClass('ml_drive_selector_unassigned');
        }

        $('<option>', { value: -1, text: 'Unassigned' }).appendTo(lSelectElement);
        lAxes.forEach(function(pAxis) {
          $('<option>', { value: pAxis.getUUID(), text: pAxis.getName() }).appendTo(lSelectElement);
          const lDrive = pAxis.getAxisDriveInfo(lColorIndex);
          if(lDrive) {
            lSelectElement.val(pAxis.getUUID());
            lCurrentAxis = pAxis;
          }
        });

        if (!lCurrentAxis) { lSelectElement.addClass('ml_drive_selector_unassigned'); }
        lElement.append(
          $('<div>', {class: 'h_layout spaced ml_drive_selector_element_option'}).append(
            $('<h5>', { text: 'Actuator Name' , class: 'ml_widget_label' }),
          ),
          lActuatorSelector
        );

        // Motor Direction
        lElement.append(
          $('<div>', {class: 'h_layout spaced ml_drive_selector_element_option'}).append(
            $('<h5>', { text: 'Motor Direction' , class: 'ml_widget_label'}),
            lMakeInstructionTooltip('assign_drive_direction')
          )
        );
        const lRotationWidget = widgets.select('Motor Direction'); //.css({ flex: 1 }),
        const lRotation = lRotationWidget.getSelect().append($('<option value="1">Normal</option>'), $('<option value="-1">Reverse</option>'));
        lElement.append(lRotationWidget);
        if (!lCurrentAxis) {
          lRotation.addClass('ml_drive_selector_unassigned');
          lRotation.prop('disabled', true);
        }

        // Parent UI
        if (pCCErrorMsg == undefined) {
          lElement.append(
            $('<div>', {class: 'h_layout spaced ml_drive_selector_element_option'}).append(
              // NOTE: if it is a one-drive, the header will be grey out.
              $('<h5>', { text: 'Synchronization Level', class: 'ml_widget_label'}).css( lIsOneDrive ? {color:"#C5C5C5"} : {}),
              lMakeInstructionTooltip('assign_drive_synchronization')
            )
          );
        }


        const lParentCheckbox = view_widgets.checkboxWidget('Parent', true);
        lParentCheckbox.addClass('ml_drive_selector_unassigned');

        // var lParentCheckbox = widgets.checkBoxParameter('Parent', true);

        if (pCCErrorMsg == undefined) {
          lParentCheckbox.appendTo(lElement);
        }
        lParentCheckbox.find('label').trigger('set_checked', true);
        lParentCheckbox.find('label').trigger('set_disabled', true);

        const lCreateOnDriveParentCheckboxChange = function(pDrive) {
          return function(pEvent) {
            // only process on checked,
            if(!pEvent.target.checked) { return; }

            // for simplicity, we will uncheck everyone, and recheck the selected one
            lAxisOptionUi.map(function(pUi) {
              if(pUi.name.val() == lAxisOptionUi[pDrive].name.val()) {
                pUi.parentCheckbox.trigger('set_checked', false);
                pUi.parentCheckbox.trigger('set_disabled', false);
                pUi.parentCheckboxTop.removeClass('ml_drive_selector_unassigned');
              }
            });
            lAxisOptionUi[pDrive].parentCheckbox.trigger('set_checked', true);
            lAxisOptionUi[pDrive].parentCheckbox.trigger('set_disabled', true);
            lAxisOptionUi[pDrive].parentCheckboxTop.addClass('ml_drive_selector_unassigned');
          };
        };
        lParentCheckbox.change(lCreateOnDriveParentCheckboxChange(lColorIndex));

        // sync the UI with data
        if(lCurrentAxis) {
          const lDriveInfo = lCurrentAxis.getAxisDriveInfo(lColorIndex);
          if(lDriveInfo) { lRotation.val(lDriveInfo.direction.toString()); }

          lParentCheckbox.find('label').trigger('set_checked', lCurrentAxis.getColor() == pConfig.getColors()[lColorIndex]);
          if(lCurrentAxis.getColor() != pConfig.getColors()[lColorIndex]) { lParentCheckbox.removeClass('ml_drive_selector_unassigned'); }

          if(lCurrentAxis.isMultiDriveAxis()) {
            lParentCheckbox.find('label').trigger('set_disabled', lDriveInfo && lDriveInfo.isParent ? true : false);
          }
        }
        // mostly ui elements
        lAxisOptionUi.push({
          name: lSelectElement,
          direction: lRotation,
          parentCheckbox: lParentCheckbox.find('label'),
          parentCheckboxTop: lParentCheckbox, // This is for convenience, as the checkbox is construction of divs and labels and stuff
          axis: lCurrentAxis
        });
      }

      // this will be used as for diff when saving
      lAxisToDriveMapOnCreation = makeAxisDriveMap();

      lFooter.append([
        $('<button>', { class: 'ml_modal_button inverse', text: "Cancel", click: function() { lModalContainer.remove(); } }),
        $('<button>', {
          class: 'ml_modal_button', text: "Save", click: function() {
            const lAxisToDriveMap = makeAxisDriveMap();
            const lResult = validateAxesCombine(lAxisToDriveMapOnCreation, lAxisToDriveMap);
            if(lResult) {
              if(lResult.success) {
                // no changes
                lModalContainer.remove();
              }
              else if(lResult.update) {
                // we will not display anything to the user for the moment
                updateAxes(lAxisToDriveMap);
                lModalContainer.remove();
              }
              else if(lResult.error) {
                widgets.messageBox(lResult.error, 'warning');
              }
              else { console.warn('Not supported status', lResult); }
            }
          }
        }),
      ]);
    };

    lPopulateModal();
  }

  function showApplyConfigurationModal(pOnYes, pOnNo) {

    style.defineCssRule('.ml_confirmation_modal', 'width: 500px !important; box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2); overflow: hidden; padding: 1rem 4rem; background-color: #FFF; font-family: Larsseit; position: relative;');
    style.defineCssRule('.ml_confirmation_modal .ml_modal_close', 'position: absolute; top: 10px; right: 10px; color: c2c2c2; cursor: pointer;');
    style.defineCssRule('.ml_confirmation_modal .ml_modal_close:hover', 'color: #bababa');
    style.defineCssRule('.ml_confirmation_modal button', 'height: 50px; padding: 0px 23px; font-family: Larsseit; font-style: normal; font-weight: 500; font-size: 18px; line-height: 18px; border-radius: 3px; border: 1px solid ##1C344F; color: #1C344F;');

    function showConfirmationModal(pTitle, pSubTitle, pYes, pNo, pOnConfirm, pOnCancel, pExtra) {
      const lModalContainer = $('<div>', { class: 'ml_modal_container' }).appendTo('body');
      const lModal = $('<div>', { class: 'ml_confirmation_modal' }).appendTo(lModalContainer);

      $('<div class="ml_modal_close fal fa-times">')
        .click(() => { lModalContainer.remove(); /* NOTE: we dont call any callback here, as we would do normally */ })
        .appendTo(lModal);

      const lHeader = $('<div>')
        .css({ 'margin': '20px 0 20px 0', 'display': 'flex', 'justify-content': 'center', 'align-items': 'center', 'flex-direction': 'column', 'position': 'relative'})
        .append(
          // Title
          $('<div>').text(pTitle).css({
            'text-align': 'center', 'font-style': 'normal', 'font-weight': 500, 'font-size': '24px', 'line-height': '29px'
          }),
          // SubTitle
          $('<div>').text(pSubTitle).css({
            'text-align': 'center', 'font-style': 'normal', 'font-weight': 'normal', 'font-size': '18px', 'line-height': '18px', 'padding-top': '23px'
          }
          )
        );

      const lFooter = $('<div>')
        .css({'margin': '32px 0px', 'display': 'flex', 'align-items': 'center'})
        .append(
          $('<button>')
            .text(pNo)
            .css({'background': 'white', 'flex': 1, 'margin': '5px'})
            .click(function() { if(pOnCancel) { pOnCancel(); } lModalContainer.remove(); }),
          $('<button>')
            .text(pYes)
            .css({ 'background': '#1C344F', 'color': 'white', 'flex': 1, 'margin': '5px'})
            .click(function() { pOnConfirm(); lModalContainer.remove(); })
        );

      lModal.append(lHeader, lFooter);

      if(pExtra) { lModal.append( $('<div>').append(pExtra)); }
    }

    showConfirmationModal(
      'Apply Changes?',
      'Do you want to apply your changes before exit?',
      "Apply changes", "Don't apply",
      pOnYes,
      pOnNo,
      _onConfigApplyWarningMessageUi()
    );
  }

  function _onConfigApplyWarningMessageUi() {
    return $('<div>').css({
      'line-height': '16px', 'font-size': '16px',
      'color': '#F4B73A',
      'padding': '10px',
      'display': 'flex', 'justify-content': 'left', 'align-items': 'center', 'gap': '10px',
    })
      .append(
        $('<div class="fal fa-2x fa-exclamation-triangle">'),
        $('<div>').text('Motors will briefly lose power upon clicking apply. Lower vertical actuators to a safe position first.')
      );
  }

  function _applyConfigurationButton(pConfigManager, onClick) {
    const lMessageUI = _onConfigApplyWarningMessageUi();
    lMessageUI.css({'padding-bottom': 0});

    const lApplyButton = $('<button>')
      .addClass('ml_apply_configuration_button button')
      .append($('<div>').text('Apply All Configurations').css({'font-size': '18px'}) )
      .click(() => {
        onClick();
      });

    lApplyButton.clear = function() {
      lApplyButton.attr('disabled', true);
      lMessageUI.hide();
    };

    lApplyButton.set = function() {
      lApplyButton.attr('disabled', false);
      lMessageUI.show();
    };

    pConfigManager.mDirty ? lApplyButton.set() : lApplyButton.clear();

    return [ lMessageUI, lApplyButton ];
  }

  function _checkboxGroupWidget() {
    const _lDiv = widgets.baseWidget().addClass('ml_checkbox_group');
    _lDiv.addCheckboxWidget = function(pWidget) {
      _lDiv.append(pWidget);
    };
    _lDiv.removeCheckboxWidget = function(pName) {
      _lDiv.find('h5').each(function () {
        if ($(this)[0].innerText === pName) {
          $(this).closest('.ml_parameter').remove();
        }
      });
    };
    return _lDiv;
  }

  function _changeUnits(_lWidget, pNewUnits) {
    const _lNewUnits = $('<div class="ml_parameter_unit">' + pNewUnits.replace(/\^([0-9]+)/g, '<sup>$1</sup>') + '</div>');
    _lWidget.children(".ml_parameter_widget").children(".ml_parameter_unit").replaceWith(_lNewUnits);
  }

  if (window != undefined) {
    window.showDriveSettingsModal = showDriveSettingsModal;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    configurationView: configurationView,
    showDriveSettingsModal: showDriveSettingsModal,
    showApplyConfigurationModal: showApplyConfigurationModal,
    formatAxisType: formatAxisType // leaving this export here because other teams use this. Eventually, we should make everyone import from helpers.js
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();
